export enum TrailerSortType {
  STATUS = 1,
  EARLIEST_TIME = 2,
  LATEST_TIME = 3,
  TYPE = 4,
  SLIC = 5,
  CUSTOMER_ID = 6,
  UNREAD_COMMENTS = 7
}
